import { useEffect, useRef, useState } from 'react'

interface HeroProps {
  onVideoEnd: () => void
  bannerImage?: string
  bannerUrl?: string
}


const Hero = ({ onVideoEnd, bannerUrl, bannerImage }: HeroProps) => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const mobileVideoRef = useRef<HTMLVideoElement>(null)

  const [mode, setMode] = useState<'video' | 'banner'>('video')
  const [videoKey, setVideoKey] = useState(0)

  // Force autoplay when video mounts
  useEffect(() => {
    if (mode === 'video') {
      const v1 = videoRef.current
      const v2 = mobileVideoRef.current

      if (v1) {
        v1.muted = true
        v1.play().catch(() => {})
      }
      if (v2) {
        v2.muted = true
        v2.play().catch(() => {})
      }
    }
  }, [mode, videoKey])

  // Video ended handler
  const handleVideoEnd = () => {
    if (!bannerImage) {
      onVideoEnd()
      return
    }

    setMode('banner')

    setTimeout(() => {
      setVideoKey(prev => prev + 1) // 🔥 force remount
      setMode('video')
    }, 5000)
  }

  // Enable sound after user interaction
  const enableSound = () => {
    if (videoRef.current) videoRef.current.muted = false
    if (mobileVideoRef.current) mobileVideoRef.current.muted = false
  }

  const handleBannerClick = () => {
    if (bannerUrl) {
      window.open(bannerUrl, '_blank', 'noopener,noreferrer')
    }
  }

  // Banner view
  if (mode === 'banner' && bannerImage) {
    return (
      <div
        className="relative w-full min-h-[100svh] bg-black cursor-pointer"
        onClick={handleBannerClick}
      >
        <img
          src={bannerImage}
          alt="Banner"
          className="w-full h-full object-cover"
        />
      </div>
    )
  }





  // Video view
  return (
    <div className="relative w-full bg-black overflow-hidden">

      {/* Desktop */}
      <div className="hidden md:block w-full min-h-[100svh]">
        <video
          key={`desktop-${videoKey}`}
          ref={videoRef}
          className="w-full h-full object-cover"
          autoPlay
          muted
          playsInline
          controls
          onEnded={handleVideoEnd}
          onClick={enableSound}
        >
          <source
            src={`${import.meta.env.BASE_URL}desktop-hero-video.mp4`}
            type="video/mp4"
          />
        </video>
      </div>

      {/* Mobile */}
      <div className="block md:hidden w-full min-h-[100svh]">
        <video
          key={`mobile-${videoKey}`}
          ref={mobileVideoRef}
          className="w-full h-full object-cover"
          autoPlay
          muted
          playsInline
          controls
          onEnded={handleVideoEnd}
          onClick={enableSound}
        >
          <source
            src={`${import.meta.env.BASE_URL}mobile-hero-video.mp4`}
            type="video/mp4"
          />
        </video>
      </div>

    </div>
  )
}

export default Hero
